import { Button, Checkbox, IconButton, Tooltip } from '@material-ui/core';
import { BaseSyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
	groupSelectorProps,
	testGroupDataProps,
} from '../Types/WhatsappCampaign.types';
import { PagedGroupsFilter } from '../../../../hooks/useServerPagedGroups';
import Groups from './Groups/Groups';
import clsx from "clsx";
import { BsInfoCircle } from 'react-icons/bs';

const GroupSelector = ({
	classes,
	showTestGroups,
	testGroupList,
	fetchPage,
	reloadToken,
	onSelectAllGroups,
	totalRecipients,
	selectedGroups,
	isFilterSelected,
	isCreateNewGroup,
	setIsCreateNewGroup,
	onNewGroupChange,
	newGroupName,
	onNewGroupSave,
	setSelected,
	allGroupsSelected,
	setIsFilterModal,
	setAllGroupsSelected,
	setShowTestGroups,
}: groupSelectorProps) => {
	const { t: translator } = useTranslation();

	const onSelectedGroups = (group: testGroupDataProps) => {
		const found = selectedGroups
			.map((group) => {
				return group.GroupID;
			})
			.includes(group.GroupID);
		if (found) {
			setSelected(selectedGroups.filter((g) => g.GroupID !== group.GroupID));
		} else {
			setSelected([...selectedGroups, group]);
		}
	};

	const onUpdateGroups = (value: testGroupDataProps[]) => {
		setSelected(value);
	};

	const onReciFilter = () => {
		setIsFilterModal(true);
	};

	// PR-3790: the picker is paged, so the browser no longer holds every group to
	// copy into the selection. The parent asks the server for the matching
	// identifiers instead, using the picker's current filter.
	const onSelectAll = async (filter?: PagedGroupsFilter) => {
		// Test groups are pinned from their own endpoint rather than paged, so
		// they are handed over separately - otherwise "select all" with the test
		// groups toggle on would quietly leave them out.
		await onSelectAllGroups(
			!allGroupsSelected,
			filter,
			showTestGroups ? testGroupList : []
		);
		setAllGroupsSelected(!allGroupsSelected);
	};

	const onShowTestGroup = async (showTestGroups: boolean) => {
		if (!showTestGroups && testGroupList?.length > 0) {
			setShowTestGroups(true);
		} else {
			setShowTestGroups(false);
		}
	};
	return (
		<>
			<Groups
				classes={classes}
				// PR-3790: rows are paged in by the picker. Test groups still come
				// from their own endpoint, so they are pinned above the paged rows.
				list={[]}
				fetchPage={fetchPage}
				reloadToken={reloadToken}
				pinnedRows={showTestGroups ? testGroupList : []}
				showTestGroups={showTestGroups}
				selectedList={selectedGroups}
				callbackSelectedGroups={onSelectedGroups}
				callbackUpdateGroups={onUpdateGroups}
				callbackSelectAll={onSelectAll}
				callbackReciFilter={onReciFilter}
				callbackShowTestGroup={onShowTestGroup}
				isFilterSelected={isFilterSelected}
				uniqueKey={'groups_1'}
				innerHeight={325}
				showSortBy={true}
				showFilter={true}
				showSelectAll={true}
			/>
			<div className={classes.groupsFooter}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}>
					<div className={classes.createGroupContainer}>
						<Checkbox
							// It will be available when user selects two or more groups.(it is for creating new group combining two or more groups)
							disabled={selectedGroups.length < 2}
							checked={isCreateNewGroup}
							color='primary'
							inputProps={{ 'aria-label': 'secondary checkbox' }}
							onClick={() => {
								setIsCreateNewGroup(!isCreateNewGroup);
							}}
						/>
						<span
							className={
								// It will be available when user selects two or more groups.(it is for creating new group combining two or more groups)
								selectedGroups.length >= 2
									? classes.createGroupSpan
									: classes.createGroupSpanDisabled
							}>
							<>{translator('mainReport.createNewGroup')}</>
						</span>
					</div>
					{isCreateNewGroup && (
						<div className={classes.whatsappSaveGroupWrapper}>
							<input
								type='text'
								className={classes.groupInput}
								placeholder={translator('smsReport.groupName')}
								onChange={(e: BaseSyntheticEvent) =>
									onNewGroupChange(e.target.value)
								}
								value={newGroupName}
							/>
							<Button
                size='medium'
                color="primary"
                variant='contained'
                key={"extraButton"}
                className={
                    clsx(
                        classes.btn, classes.btnRounded, classes.mlr10
                    )
                }
                onClick={onNewGroupSave}
            >
                {translator("mainReport.save")}
            	</Button>
							{/* <span
								className={classes.whatsappSaveBtn}
								onClick={onNewGroupSave}>
								<>{translator('mainReport.save')}</>
							</span> */}
						</div>
					)}
				</div>
				<div
					style={{
						display: 'flex',
						marginTop: '10px',
						marginBottom: '10px',
					}}>
					<span>
						<>{translator('mainReport.totalReci')}</>:{' '}
						{/* PR-3790: after "select all" the selection holds identifiers
						    rather than full group objects, so the total is computed by
						    the server. The figure shown is the same either way. */}
						{totalRecipients?.toLocaleString()}
					</span>
					<Tooltip
						placement={'bottom'}
						disableFocusListener
						title={translator('smsReport.finalReciTip')}
						classes={{ tooltip: classes.customWidth }}
						style={{ marginInlineStart: '5px' }}
					>
						<IconButton
							style={{ paddingInline: 5, paddingBlock: 0 }}
							className={clsx(classes.icon_Info, classes.f18)}
							aria-label={translator("mainReport.toolTip1")}
						>
							<BsInfoCircle />
						</IconButton>
					</Tooltip>
				</div>
			</div>
		</>
	);
};
export default GroupSelector;
